export const ComplianceSettingsPaths = {
    contactRestrictions: "contact-restrictions",
    holidays: "holidays",
    callLimits: "call-limits",
    stateOfEmergency: "state-of-emergency",
} as const;
